function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// copied from:
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/8adcdb05a31205b122067c1b649c525db8bf224d/src/components/Connected/RefResolverPicker/components/PickerPanel.jsx
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/8adcdb05a31205b122067c1b649c525db8bf224d/src/components/Connected/RefResolverPicker/components/SecretPanel.jsx

import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Column, Grid, Toggle } from "@carbon/react";
// import { useTranslation } from cloud-pal-community "src/Utilities";
import mockData from "./hooks/apiMockData/resolver";
// import { parseReference } from "../../utils/RefResolverUtils";

// Components
import ApiCombo from "./ApiCombo";

// Hooks
import useApi from "./hooks/useApi";

// Context
import PickerContext from "./context/PickerContext";
import usePartialToolData from "./hooks/usePartialToolData";
var RefResolverSecretFields = function RefResolverSecretFields(_ref) {
  var mock = _ref.mock,
    envId = _ref.envId,
    toolchainId = _ref.toolchainId,
    vaultIntegrations = _ref.vaultIntegrations,
    onMultipleFieldsChange = _ref.onMultipleFieldsChange,
    i18n = _ref.i18n,
    accountContext = _ref.accountContext,
    bssAccount = _ref.bssAccount,
    instanceIntegrationName = _ref.instanceIntegrationName,
    useCache = _ref.useCache,
    ancestorLoading = _ref.ancestorLoading;
  var accountId = bssAccount;
  var hidden = false;
  // State
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    instance = _useState2[0],
    setInstance = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    instances = _useState4[0],
    setInstances = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    instanceId = _useState6[0],
    setInstanceId = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    tool = _useState8[0],
    setTool = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    correlateError = _useState0[0],
    setCorrelateError = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    instanceFilterVisible = _useState10[0],
    setInstanceFilterVisible = _useState10[1];
  // TODO there"s nothing calling setRefreshId; the ApiCombo Refresh button for item doesn"t call it.
  // eslint-disable-next-line no-unused-vars
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    refreshId = _useState12[0],
    setRefreshId = _useState12[1];
  var showFilters = instanceFilterVisible;

  // State
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    group = _useState14[0],
    setGroup = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    type = _useState16[0],
    setType = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    item = _useState18[0],
    setItem = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    kvKey = _useState20[0],
    setKvKey = _useState20[1];
  var _useState21 = useState(true),
    _useState22 = _slicedToArray(_useState21, 2),
    groupLoading = _useState22[0],
    setGroupLoading = _useState22[1];
  var _useState23 = useState(true),
    _useState24 = _slicedToArray(_useState23, 2),
    typeLoading = _useState24[0],
    setTypeLoading = _useState24[1];
  var _useState25 = useState(true),
    _useState26 = _slicedToArray(_useState25, 2),
    itemLoading = _useState26[0],
    setItemLoading = _useState26[1];

  // TODO translate strings
  // const { t } = useTranslation();
  var t = function t(translatableString) {
    return translatableString;
  };

  // Context
  //   const { env_id: envId, useCache } = useContext(PickerContext);
  var pickerContextObj = useMemo(function () {
    // create the pickerContextObj in a useMemo initialization function to avoid warning:
    // https://github.com/jsx-eslint/eslint-plugin-react/blob/master/docs/rules/jsx-no-constructed-context-values.md
    return {
      env_id: envId,
      useCache: useCache
    };
  }, [envId, useCache]);

  // Refs
  // const prevHidden = useRef(true);
  var parsedRef = useRef(null);

  // Misc
  var showKeyControls = (item === null || item === void 0 ? void 0 : item.type_id) === "kv" || (item === null || item === void 0 ? void 0 : item.type_id) === "service_credentials" || (item === null || item === void 0 ? void 0 : item.type_id) === "username_password";
  var providerId = "secrets-manager";
  // Local data
  var crncname = (envId || "").startsWith("ibm:ys1:") ? "staging" : "bluemix";
  var instanceCRN = "crn:v1:".concat(crncname, ":public:secrets-manager:").concat(instance === null || instance === void 0 ? void 0 : instance.region_id, ":a/").concat(accountId, ":").concat(instanceId, "::");
  // Note, do not need to showInstance combo, but do need to do background request for it.
  var showInstance = false;

  // Datahooks
  var common = _objectSpread({
    mock: mock,
    refetchOnMount: !useCache
  }, envId ? {
    queryParams: {
      env_id: envId
    }
  } : {});

  // Special hook to retrieve the instances, only used when the instance combo is not visible
  var instancesResponse = useApi({
    options: _objectSpread(_objectSpread({}, common), {}, {
      skip: hidden || showInstance,
      // in uri template: "/devops/ref-resolver/api/v1/ui/accounts/{{0}}/providers/{{1}}/apis/{{2}}"
      templateKeys: [accountId, providerId, "instances"],
      customMockObject: {
        data: {
          items: mockData.instances
        }
      }
    })
  });
  var toolResponse = usePartialToolData({
    options: {
      mock: mock,
      customMockObject: {
        data: {
          providers: mockData.partialTool.sm_story_instance.providers
        }
      },
      refetchOnMount: !useCache,
      skip: hidden || !instanceIntegrationName,
      headers: _objectSpread({
        "IBM-Account-Context": accountContext,
        "X-BSS-Account": bssAccount
      }, (vaultIntegrations === null || vaultIntegrations === void 0 ? void 0 : vaultIntegrations.length) > 0 ? {
        "vti-instances": JSON.stringify(vaultIntegrations)
      } : {}),
      queryParams: _objectSpread({
        action: "list",
        reference: "{vault::".concat(instanceIntegrationName, "}"),
        env_id: envId
      }, toolchainId ? {
        toolchainId: toolchainId
      } : {})
    }
  });

  // during loading of hidden instance or hidden tool, show spinners in combos.
  var hiddenInstanceLoading = !showInstance && instancesResponse.loading || toolResponse.loading;
  var hiddenInstanceError = instancesResponse.error || toolResponse.error || correlateError;
  var parentLoading = ancestorLoading || !showInstance && instancesResponse.loading;
  var baseDisable = function baseDisable() {
    return hidden || parentLoading || !instanceId;
  };

  // Effects

  useEffect(function () {
    var _toolResponse$data;
    if (!toolResponse.loading && !toolResponse.error && (_toolResponse$data = toolResponse.data) !== null && _toolResponse$data !== void 0 && _toolResponse$data.providers[0]) {
      var toolcardInfo = {
        type: toolResponse.data.providers[0].type,
        region: toolResponse.data.providers[0].region,
        resource_group: toolResponse.data.providers[0].resource_group,
        instance_name: toolResponse.data.providers[0].instance_name,
        integration_name: toolResponse.data.providers[0].integration_name
      };
      var toolcardTypeToProviderType = {
        sm: "secrets-manager",
        kp: "keyprotect"
      };

      // Convert most fields from toolcard syntax to ref-resolver SM instances syntax
      var toolInfo = {
        // id: // unknown
        name: toolcardInfo.instance_name,
        // remove prefix from ibm:yp:us-south
        region_id: toolcardInfo.region.includes(":") ? toolcardInfo.region.split(":").pop() : toolcardInfo.region,
        resource_group_name: toolcardInfo.resource_group,
        // account_id: unknown
        provider_id: toolcardTypeToProviderType[toolcardInfo.type] || toolcardInfo.type,
        // extra, not in SM instance:
        integration_name: toolcardInfo.integration_name
      };
      setTool(toolInfo);
    }
  }, [toolResponse.loading, toolResponse.error, toolResponse.data, instanceIntegrationName]);

  // This effect should only be triggered when the instance combo is not visible
  useEffect(function () {
    var _instancesResponse$da;
    if (!showInstance && !instancesResponse.loading && !instancesResponse.error && (_instancesResponse$da = instancesResponse.data) !== null && _instancesResponse$da !== void 0 && _instancesResponse$da.items) {
      var _instancesResponse$da2;
      var foundArr = (_instancesResponse$da2 = instancesResponse.data) === null || _instancesResponse$da2 === void 0 ? void 0 : _instancesResponse$da2.items;
      setInstances(foundArr);
    }
  }, [instancesResponse.data, instancesResponse.error, instancesResponse.loading, showInstance]);
  useEffect(function () {
    if (tool && instances) {
      // Find the matches between instances response, with list of entries,
      // and the toolcard response.
      var foundMatches = instances.filter(function (entry) {
        var differs;
        // provider "secrets-manager"
        differs = tool.provider_id !== entry.provider_id;
        differs = differs || tool.region_id !== entry.region_id;
        differs = differs || tool.resource_group_name !== entry.resource_group_name;
        differs = differs || tool.name !== entry.name;
        // only match SM instances in current account
        differs = differs || accountId !== entry.account_id;
        return !differs;
      });
      if (foundMatches.length === 1) {
        // There should be only one result; toolcard points to a single SM instance, SM instances not dupe
        setCorrelateError(false);
        setInstance(foundMatches[0]);
        setInstanceId(foundMatches[0].id);
        var _fields = {
          region: foundMatches[0].region_id,
          resource_group_name: foundMatches[0].resource_group_name,
          resource_group: foundMatches[0].resource_group_name,
          instance: foundMatches[0].name
        };
        onMultipleFieldsChange(_fields, {
          hasError: false,
          callback: undefined
        });
        return;
      }
      // fall through: no match
      // e.g. out-of-date SM-tool no longer matches any SM service instance.
      if (console.warn) {
        console.warn("[SecretInput.RefResolverSecretFields] " + "Problem loading secrets. " + "The Secrets Manager tool-integration points to a Secrets Manager " + "instance that could not be found in the account. (correlateError)");
      }
      setCorrelateError(true);
      setInstance(null);
      setInstanceId(null);
      var fields = {
        region: "",
        resource_group_name: "",
        resource_group: "",
        instance: ""
      };
      onMultipleFieldsChange(fields, {
        hasError: false,
        callback: undefined
      });
    }
    // else null tool or null instances.
    // Note, on initial load then null because toolResponse.loading or instancesResponse.loading,
    // but there"s a use-case where
    // (toolResponse.data and instancesResponse.data
    //   and null tool and null instance)
    // in the case where:
    // open picker, initially selects KeyProtect tool,
    // change to ref-sm tool, change to KP tool,
    // then change back to sm-tool; then will have data but null state.
  }, [instances, tool]);

  // useEffect(() => {
  //   if (refreshId > 0) {
  //     toolResponse.refetch();
  //     instancesResponse.refetch();
  //   }
  // }, [refreshId]);

  // Callbacks

  // const onRefresh = useCallback(() => {
  //   setRefreshId(refreshId + 1);
  // }, [refreshId]);

  var onItemChange = useCallback(function (selectedItem) {
    // Note, initially called with selectedItem as null
    setItem(selectedItem);
    var fields = {
      group: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.group_name) || "",
      secret: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name) || ""
    };
    onMultipleFieldsChange(fields, {
      hasError: false,
      callback: undefined
    });
  }, []);
  var onKvKeyChange = useCallback(function (selectedKvKey) {
    setKvKey(selectedKvKey);
    var fields = {
      // kvKey is called "field" in outer SecretPickerDialog
      field: (selectedKvKey === null || selectedKvKey === void 0 ? void 0 : selectedKvKey.name) || ""
    };
    onMultipleFieldsChange(fields, {
      hasError: false,
      callback: undefined
    });
  }, []);

  // Utility functions
  var getItemDisplayName = function getItemDisplayName(i) {
    if (!i) {
      return "";
    }
    var i18nStrings = i18n.messages;
    switch (i.type_id) {
      case "arbitrary":
        return "".concat(i.name, " ").concat(i18nStrings.arbitraryType);
      case "iam_credentials":
        return "".concat(i.name, " ").concat(i18nStrings.iamCredentialsType);
      case "service_credentials":
        return "".concat(i.name, " ").concat(i18nStrings.serviceCredentialsType);
      case "username_password":
        return "".concat(i.name, " ").concat(i18nStrings.userCredentialsType);
      case "kv":
        return "".concat(i.name, " ").concat(i18nStrings.kvType);
      default:
    }
    return i.name;
  };

  // Renderers

  var renderFilterToggle = function renderFilterToggle(_ref2) {
    var disabled = _ref2.disabled,
      id = _ref2.id,
      toggled = _ref2.toggled,
      onToggle = _ref2.onToggle;
    return (
      /*#__PURE__*/
      // TODO new translatable string.
      React.createElement("div", null, /*#__PURE__*/React.createElement(Toggle, {
        className: "cpc--ref-resolver-picker__filter_toggle",
        disabled: disabled,
        toggled: toggled,
        id: id
        // hideLabel: use "[] sideLabel" instead of "label:" with colon on a line before
        ,
        hideLabel: true,
        labelText: t(i18n.messages.showFilters),
        size: "sm",
        onToggle: onToggle
      }))
    );
  };
  var renderGroupCombo = function renderGroupCombo() {
    return /*#__PURE__*/React.createElement(ApiCombo, {
      apiOptions: {
        mock: mock,
        accountId: accountId,
        providerId: providerId,
        apiId: "groups",
        queryParams: {
          instance_id: instanceId
        },
        mockItems: mock && mockData.groups
      },
      autoSelect: false,
      comboId: "ref-resolver-picker-combo-group",
      disabled: baseDisable(),
      forceLoading: hiddenInstanceLoading,
      itemId: (group === null || group === void 0 ? void 0 : group.id) || null,
      onChanged: setGroup,
      onLoading: setGroupLoading,
      parsedRef: parsedRef,
      parsedRefField: "group",
      parsedRefItemField: "name_escaped",
      refreshId: refreshId,
      text: {
        title: t(i18n.messages.secretGroup),
        placeholder: t(i18n.messages.allSecretGroups),
        loadError: t(i18n.messages.errorLoadingGroups)
      }
    });
  };
  var renderTypeCombo = function renderTypeCombo() {
    return /*#__PURE__*/React.createElement(ApiCombo, {
      apiOptions: {
        mock: mock,
        accountId: accountId,
        providerId: providerId,
        apiId: "types",
        queryParams: {
          instance_id: instanceId
        },
        mockItems: mock && mockData.types
      },
      autoSelect: false,
      comboId: "ref-resolver-picker-combo-type",
      disabled: baseDisable(),
      forceLoading: hiddenInstanceLoading,
      itemId: (type === null || type === void 0 ? void 0 : type.id) || null,
      onChanged: setType,
      onLoading: setTypeLoading,
      parsedRef: parsedRef,
      parsedRefField: "type",
      parsedRefItemField: "id",
      refreshId: refreshId,
      text: {
        title: t(i18n.messages.secretType),
        placeholder: t(i18n.messages.allTypes),
        loadError: t(i18n.messages.errorLoadingTypes)
      }
    });
  };
  var renderItemCombo = function renderItemCombo() {
    var itemsQueryParams = showFilters && (group || type) && _objectSpread(_objectSpread({}, group ? {
      group_id: group.id
    } : {}), type ? {
      type_id: type.id
    } : {});
    var disabledItemCombo = baseDisable() || showFilters && (groupLoading || typeLoading);
    return /*#__PURE__*/React.createElement(ApiCombo, {
      apiOptions: {
        mock: mock,
        accountId: accountId,
        providerId: providerId,
        apiId: "items",
        queryParams: _objectSpread({
          instance_id: instanceId
        }, itemsQueryParams),
        mockItems: mock && mockData.items
      },
      comboId: "ref-resolver-picker-combo-item",
      customItemToString: getItemDisplayName,
      disabled: disabledItemCombo,
      forceLoading: hiddenInstanceLoading,
      forceError: hiddenInstanceError,
      itemId: (item === null || item === void 0 ? void 0 : item.id) || null,
      onChanged: onItemChange,
      onLoading: setItemLoading,
      parsedRef: parsedRef,
      parsedRefField: "item",
      parsedRefItemField: "name_escaped",
      linkUrl: disabledItemCombo ? "" : "/services/secrets-manager/".concat(encodeURIComponent(instanceCRN)),
      refreshId: refreshId,
      showRefresh: true,
      text: {
        title: t(i18n.messages.secret),
        placeholder: t(i18n.messages.chooseSecret),
        loadError: t(i18n.messages.errorLoadingSecrets),
        linkText: t(i18n.messages.createSecret),
        refresh: t(i18n.messages.refreshData),
        noneAvailable: t(i18n.messages.noneAvailable)
      }
    });
  };
  var renderKeyCombo = function renderKeyCombo() {
    return /*#__PURE__*/React.createElement(ApiCombo, {
      apiOptions: {
        mock: mock,
        accountId: accountId,
        providerId: providerId,
        apiId: "keys",
        queryParams: {
          instance_id: instanceId,
          item_id: item === null || item === void 0 ? void 0 : item.id
        },
        mockItems: mock && mockData.keys
      },
      autoSelect: false,
      comboId: "ref-resolver-picker-combo-key",
      disabled: baseDisable() || !item || !showKeyControls || showFilters && (groupLoading || typeLoading) || itemLoading,
      itemId: (kvKey === null || kvKey === void 0 ? void 0 : kvKey.id) || null,
      onChanged: onKvKeyChange,
      parsedRef: parsedRef,
      parsedRefField: "key",
      parsedRefItemField: "name_escaped",
      refreshId: refreshId,
      text: {
        title: t(i18n.messages.key),
        placeholder: t(i18n.messages.entireSecretMsg),
        loadError: t(i18n.messages.errorLoadingKeys)
      }
    });
  };
  var renderSecretPanel = function renderSecretPanel() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Column, {
      sm: 4,
      md: 8,
      lg: 16
    }, renderFilterToggle({
      id: "filter_instance_toggle",
      toggled: instanceFilterVisible,
      onToggle: function onToggle(checked) {
        return setInstanceFilterVisible(checked);
      },
      disabled: !providerId || !accountId
    })), /*#__PURE__*/React.createElement(Column, {
      className: classNames("cpc--ref-resolver-picker__hidden_row", {
        show: showFilters
      }),
      sm: 4,
      lg: 8
    }, renderGroupCombo()), /*#__PURE__*/React.createElement(Column, {
      className: classNames("cpc--ref-resolver-picker__hidden_row", {
        show: showFilters
      }),
      sm: 4,
      lg: 8
    }, renderTypeCombo()), /*#__PURE__*/React.createElement(Column, {
      sm: 4,
      md: 8,
      lg: 16
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flexGrow: 1
      }
    }, renderItemCombo()))), /*#__PURE__*/React.createElement(Column, {
      className: classNames("cpc--ref-resolver-picker__hidden_row", {
        show: showKeyControls
      }),
      sm: 4,
      md: 8,
      lg: 16
    }, renderKeyCombo()), /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: "6.5rem"
      }
    }));
  };
  return /*#__PURE__*/React.createElement(PickerContext.Provider, {
    value: pickerContextObj
  }, /*#__PURE__*/React.createElement(Grid, {
    narrow: true
  }, " ", renderSecretPanel(), " "));
};
RefResolverSecretFields.propTypes = {
  mock: PropTypes.bool,
  i18n: PropTypes.object.isRequired,
  accountContext: PropTypes.string,
  bssAccount: PropTypes.string,
  instanceIntegrationName: PropTypes.string,
  ancestorLoading: PropTypes.bool,
  // initialReference: PropTypes.string,
  useCache: PropTypes.bool,
  // vaultIntegrations, different objects depending on type, per:
  // https://github.ibm.com/org-ids/otc-ui/blob/db0e6f1c141b89d393aa3acf221f8d830cd114b5/lib/client/vault-util.js#L35
  vaultIntegrations: PropTypes.arrayOf(PropTypes.object),
  // onMultipleFieldsChange(fieldNameValuePairs, { hasError = false, callback } )
  onMultipleFieldsChange: PropTypes.func.isRequired,
  envId: PropTypes.string.isRequired,
  toolchainId: PropTypes.string.isRequired
};
RefResolverSecretFields.defaultProps = {
  mock: false,
  accountContext: null,
  bssAccount: null,
  instanceIntegrationName: null,
  ancestorLoading: false,
  // initialReference: null,
  vaultIntegrations: null,
  useCache: false
};
export default RefResolverSecretFields;
export { RefResolverSecretFields };